import { useSearchParams } from 'react-router-dom';
import { Article } from '../lib/types';
import { useEffect, useState } from 'react';
import atNodeDB from '../lib/database';

export default function Articles({ dataChanged }: { dataChanged: number }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [articles, setArticles] = useState<Article[]>([]);
  const [showPager, setShowPager] = useState<boolean>(false);

  useEffect(() => {
    const loadArticles = async () => {
      const keywords: number[] = searchParams.get('selectedKeywords')?.split(',').map(Number) || [];
      const questions: number[] = searchParams.get('selectedQuestions')?.split(',').map(Number) || [];
      const [loadedArticles, thereIsMore] = await atNodeDB.loadArticles(keywords, questions, searchParams.get('searchArticles') || '', 20);
      setArticles(loadedArticles);
      setShowPager(thereIsMore);
    };
    loadArticles();
  }, [searchParams, dataChanged]);

  async function searchArticles(search: string) {
    if (search) {
      searchParams.set('searchArticles', search);
    } else {
      searchParams.delete('searchArticles');
    }
    setSearchParams(searchParams);
  }
  return (
    <div className='box'>
      <div className='search-box'>
        <input
          type="text"
          onFocus={(e) => e.target.select()}
          onChange={async (e) => searchArticles(e.target.value)}
          // defaultValue={searchParams.get('searchArticles')?.toString()}
          placeholder="Search articles"
          className="input-search"
        />
      </div>
      <div className="items-box">
        {articles.map((article) => {
          return (
            <a key={`article${article.Id}`} href={article.Url} target="_blank" rel='noreferrer'>
              <div className="link-article">{article.Title}</div>
            </a>
          );
        })}
        {showPager && (
          <div className="pager">
            ...more
          </div>
        )}
      </div>
    </div>
  );
}
